declare namespace $ {

	type $mol_check_icon__hint_shm_hitalama_components_drafts_preview_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_icon['hint'] >
	>
	type $mol_check_icon__checked_shm_hitalama_components_drafts_preview_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_drafts_preview['editing'] >
		,
		ReturnType< $mol_check_icon['checked'] >
	>
	type $mol_check_icon__Icon_shm_hitalama_components_drafts_preview_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_drafts_preview['Edit_icon'] >
		,
		ReturnType< $mol_check_icon['Icon'] >
	>
	type $mol_button_minor__hint_shm_hitalama_components_drafts_preview_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_shm_hitalama_components_drafts_preview_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_drafts_preview['close'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_components_drafts_preview_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $shm_hitalama_text__text_shm_hitalama_components_drafts_preview_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_drafts_preview['text'] >
		,
		ReturnType< $shm_hitalama_text['text'] >
	>
	export class $shm_hitalama_components_drafts_preview extends $mol_page {
		draft_title( ): string
		Edit_icon( ): $mol_icon_pencil
		Edit( ): $mol_check_icon
		edit_tools( ): readonly($mol_view)[]
		close( next?: any ): any
		Close_icon( ): $mol_icon_close
		Close( ): $mol_button_minor
		text( ): string
		Content( ): $shm_hitalama_text
		model( ): $shm_hitalama_components_drafts_model
		selected( ): string
		editing( next?: boolean ): boolean
		title( ): ReturnType< $shm_hitalama_components_drafts_preview['draft_title'] >
		minimal_width( ): number
		tools( ): readonly(any)[]
		body( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=preview.view.tree.d.ts.map